import { FaqTemplateDataModel } from '@/types/home';
import { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import styles from './index.module.less';

export default function FaqContent({
  faqList,
  faqInfo,
}: {
  faqList: FaqTemplateDataModel;
  faqInfo: {
    title?: string;
    desc?: string;
  };
}) {
  const firstItemId = faqList?.content_list?.[0]?.id ?? -1;
  const [selectIndex, setSelectIndex] = useState<number>(firstItemId);
  const contentRefs = useRef<{ [key: number]: HTMLDivElement | null }>({});
  const answerWrapperRefs = useRef<{ [key: number]: HTMLDivElement | null }>({});

  const toggleFaq = (id: number) => {
    setSelectIndex(selectIndex === id ? -1 : id);
  };

  // 动态设置内容高度
  useEffect(() => {
    faqList?.content_list?.forEach((item) => {
      const contentEl = contentRefs.current[item.id];
      const answerWrapper = answerWrapperRefs.current[item.id];

      if (contentEl && answerWrapper) {
        if (selectIndex === item.id) {
          // 展开时，设置为实际高度
          contentEl.style.height = `${answerWrapper.scrollHeight}px`;
        } else {
          // 折叠时，设置为0
          contentEl.style.height = '0px';
        }
      }
    });
  }, [selectIndex, faqList]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        {faqInfo?.title && <h2 className={styles.title}>{faqInfo.title}</h2>}
        {faqInfo?.desc && <p className={styles.desc}>{faqInfo.desc}</p>}
      </div>

      <div className={styles.faqList}>
        {faqList?.content_list?.map((item) => {
          const isActive = selectIndex === item.id;
          return (
            <div key={item.id} className={styles.faqItem}>
              <button onClick={() => toggleFaq(item.id)} className={styles.faqButton}>
                <h3 className={styles.question} dangerouslySetInnerHTML={{ __html: item.question }} />
                <ChevronDown className={`${styles.icon} ${isActive ? styles.iconActive : ''}`} />
              </button>

              <div
                ref={(el) => (contentRefs.current[item.id] = el)}
                className={`${styles.content} ${isActive ? styles.contentActive : ''}`}
              >
                <div ref={(el) => (answerWrapperRefs.current[item.id] = el)} className={styles.answerWrapper}>
                  <div className={styles.answer} dangerouslySetInnerHTML={{ __html: item.answer }} />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
